import { validateEmail } from '@perch-labs/warbler';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

interface UtilityEmailProps extends InputComponentProps {
  utilityName?: string;
}

export const UtilityEmail = ({ utilityName, ...props }: UtilityEmailProps) => {
  const validate = ({ value }) => {
    if (!validateEmail(value)) return 'Please enter a valid email';
    return true;
  };

  return (
    <ValidatingInput
      autoComplete="email"
      label={utilityName ? `Email for ${utilityName}` : 'Email'}
      name="utilityEmail"
      placeholder="Enter your email"
      validate={validate}
      {...props}
    />
  );
};
